const __WEBPACK_NAMESPACE_OBJECT__ = require("deep-extend");